import React from 'react';

/**
 * Bulk actions for the picker draft (IB-641): select/clear the currently filtered
 * projects and set every selected project to its evolving (Latest Estimate) budget.
 */
export default function PickerBulkActions({ onSelectAllFiltered, onClearAll, onSetAllToLatestEstimate }) {
    return (
        <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-2">
            <button type="button" onClick={onSelectAllFiltered} className="tw-text-xs tw-text-blue tw-font-medium">
                {$t('Select all filtered')}
            </button>
            <button type="button" onClick={onClearAll} className="tw-text-xs tw-text-blue tw-font-medium">
                {$t('Clear all')}
            </button>
            <button type="button" onClick={onSetAllToLatestEstimate} className="tw-text-xs tw-text-blue tw-font-medium">
                {$t('Set all versions to LE')}
            </button>
        </div>
    );
}
